<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="formDialogVisible"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="form">
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="服务类型" prop="serviceTypeId">
              <el-select
                v-model="form.serviceTypeId"
                placeholder="请选择"
                :disabled="type === 'detail'"
                size="large"
              >
                <el-option
                  v-for="item in serviceTypeOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="硬件编码" prop="code">
              <el-input
                v-model="form.code"
                :disabled="type === 'detail'"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="ICCID" prop="iccid">
              <el-input
                v-model="form.iccid"
                :disabled="type === 'detail'"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="24">
          <el-col :span="18">
            <el-form-item label="ICCID有效期" prop="expireTime">
              <el-date-picker
                :disabled="type === 'detail'"
                v-model="form.expireTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择"
              />
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
    </div>
    <template #footer v-if="type !== 'detail'">
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm('form')">
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { addHardware, getHardwareDetail, updateHardware } from '@/api/hardware';
// import { FormValidators } from '@/utils/validate';
import { getAllServiceTypeList } from '@/api/serviceType';
const titleMap = new Map([
  ['add', '新建'],
  ['edit', '编辑'],
  ['detail', '详情'],
]);
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formDialogVisible: false,
      serviceTypeOptions: [],
      dialogTitle: '',
      rules: {
        // expireTime: [
        //   { required: true, message: '请选择iccid有效期!', trigger: 'blur' },
        // ],
        serviceTypeId: [
          { required: true, message: '请选择服务类型名称!', trigger: 'blur' },
        ],
        code: [{ required: true, message: '请输入硬件编码!', trigger: 'blur' }],
        iccid: [{ required: true, message: '请输入iccid号!', trigger: 'blur' }],
      },
      form: {
        code: '',
        iccid: '',
        serviceTypeId: '',
      },
    };
  },
  created() {
    // this.initFormData();
  },
  watch: {
    // 显示隐藏双向绑定
    visible(val) {
      this.formDialogVisible = val;
      if (val) {
        this.initFormData();
      }
    },
    formDialogVisible(val) {
      this.$emit('visible-change', val);
    },
    type(val) {
      // 获取类型
      if (val) {
        this.dialogTitle = titleMap.get(val);
      }
    },
  },
  methods: {
    handleClose() {
      this.formDialogVisible = false;
      this.$refs['form'].resetFields();
    },

    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const fn = this.id ? updateHardware : addHardware;
          fn(this.form).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功!');
              this.handleClose();
              this.$emit('success');
            }
          });
        }
      });
    },
    //非空判断
    isNotEmpty(str) {
      if (str != null && str != '' && str.trim().length > 0) {
        return true;
      }
      return false;
    },
    async initFormData() {
      const { data } = await getAllServiceTypeList();
      this.serviceTypeOptions = data;
      if (this.id) {
        this.getDetail();
      }
    },
    getDetail() {
      getHardwareDetail(this.id).then((res) => {
        if (res.code == 0) {
          this.form = res.data;
        } else {
          let msg = res.message;
          this.$message.error(this.isNotEmpty(msg) ? msg : '查询异常!');
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-select,
.el-date-editor {
  width: 100%;
}
</style>
